<template>
  <div>
    <el-dialog title="修改信息" :visible.sync="updateShow" width="30%">
      <el-form label-width="120px" ref="form">
        <el-form-item label="头像">
          <avatar-uploader
            ref="imgs"
            @getImgUrl="
              (v) => {
                this.form.avatar = v;
              }
            "
            :url="temp.avatar"
          >
          </avatar-uploader>
        </el-form-item>
        <el-form-item label="昵称">
          <el-input v-model="form.name" placeholder="昵称"></el-input>
        </el-form-item>

        <el-form-item label="服务平台" required>
          <el-checkbox-group v-model="selectPlatform">
            <el-checkbox
              :label="item.value"
              v-for="(item, i) in platformList"
              :key="i"
              >{{ item.name }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
         <el-form-item label="服务平台" required>
          <el-checkbox-group v-model="selectEntry">
            <el-checkbox
              :label="item.value"
              v-for="(item, i) in entryList"
              :key="i"
              >{{ item.name }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
         <el-form-item label="招呼语">
          <el-input v-model="form.greet" placeholder="招呼语"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateShow = false">取 消</el-button>
        <el-button type="primary" @click="updateUserInfo">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

  <script>
import { entryList } from "../../../knowledgeManage/components/dict";
import { ObjectChangedValue } from "@/js/utils";
export default {
  data() {
    return {
      platformList: [
    {
      name: "海马运动",
      value: '1',
    },
    {
      name: "教练局",
      value: '2',
    }
  ],
      entryList,
      form: {},
      temp: {},
      updateShow: false,
      selectPlatform: [],
      selectEntry: []
    };
  },
  methods: {
    open(info) {
      this.temp = Object.assign({}, info);
      this.form = info;
      this.selectPlatform = info.main_platform ? info.main_platform.split(',') : []
      this.selectEntry = info.main_entry ? info.main_entry.split(',') : []
      
      this.updateShow = true;
    },
    updateUserInfo() {
      this.form.main_platform = this.selectPlatform.join(',')
      this.form.main_entry = this.selectEntry.join(',')
      let data = ObjectChangedValue(this.temp, this.form);
      if(Object.values(data).length == 0){
          this.updateShow = false;
        return
      }
      data.user_id = this.form.user_id;
     
      let url = "/chat/customerService/update";
      this.$axios.post(url, data).then((res) => {
        this.$message({ type: "success", message: "修改成功!" });
        this.updateShow = false;
        this.form = {};
        this.temp = {};
        this.$emit("success");
      });
    },
  },
};
</script>